import clevertap from "clevertap-web-sdk";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

// helpers
import parseHTML from "helpers/parseHTML";

// style
import "./style.scss";

export const SearchWidenFilter = ({ query, setRadius }: any) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [radius, setQueryRadius] = useState(query.get("radius") || 1);

	const { pathname } = useLocation();

	useEffect(() => {
		// @ts-ignore
		searchParams.set("radius", radius);
		setSearchParams(searchParams);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [radius]);

	return (
		<div className="searchwiden__filter">
			<span>
				Want to see more homes beyond{" "}
				{parseHTML(
					window.location.pathname.split("/")[1] === "villas"
						? window.location?.pathname
								?.split("/")[2]
								?.split("-")[2]
								?.replace(/%20/g, " ")
						: window.location?.pathname
								?.split("/")[2]
								?.split("-")[2]
								?.replace(/%20/g, " "),
				)}
				?
			</span>
			<button
				aria-label="search"
				type="button"
				className="btn-filter"
				onClick={() => {
					clevertap.event.push("extent_search_radius_btn_click", {
						location:
							window.location.pathname.split("/")[1] === "villas" &&
							window.location?.pathname
								?.split("/")[2]
								?.split("-")[2]
								?.replace(/%20/g, " "),
						timestamp: new Date(),
					});
					window.scrollTo(0, 0);
					setQueryRadius((prev: any) => prev + 1);
				}}
			>
				Widen search radius
			</button>
		</div>
	);
};
